import { getCustomerId } from 'utils/getCustomerId';
import { MIN_NON_MEMBER_ID } from '../constants';

export function checkIsMember() {
  const customer_id = getCustomerId();

  return customer_id > 0 && customer_id < MIN_NON_MEMBER_ID;
}
